module.exports = __webpack_public_path__ + "img/電気回路_2_2_5.2e604661.png";